import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
} from "reactstrap"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import { Button } from "@material-ui/core"

const SetPassword = props => {
  const [pwVisibility, setpwVisibility] = useState(true)
  const [repwVisibility, setrepwVisibility] = useState(true)

  const togglePwVisibility = () => {
    setpwVisibility(!pwVisibility)
  }

  const togglerePwVisibility = () => {
    setrepwVisibility(!repwVisibility)
  }

  const history = useHistory()

  const [token, setToken] = useState(null)
  const [countryCode, setCountryCode] = useState("60")
  const [phoneNumber, setPhoneNumber] = useState(null)
  const [password, setPassword] = useState(null)
  const [repassword, setrePassword] = useState(null)
  const [referralCode, setReferralCode] = useState(null)
  const [redirectId, setRedirectId] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("phoneNumber")) {
      setPhoneNumber(localStorage.getItem("phoneNumber"))
    }

    if (localStorage.getItem("countryCode")) {
      setCountryCode(localStorage.getItem("countryCode"))
    }

    if (localStorage.getItem("redirect_id")) {
      setRedirectId(localStorage.getItem("redirect_id"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  const submitResetPassword = async e => {
    e.preventDefault()
    if (password == null || password == "") {
      console.log("error", "password empty")
      seterror_alert(true)
      setdynamic_title(props.t("Password empty"))
      setdynamic_description(props.t("Please enter your new password."))
      return
    }

    if (repassword == null || repassword == "") {
      console.log("error", "repassword empty")
      seterror_alert(true)
      setdynamic_title(props.t("RePassword empty"))
      setdynamic_description(props.t("Please retype your new password."))
      return
    }

    if (password != repassword) {
      console.log("error", "password repassword mismatch")
      seterror_alert(true)
      setdynamic_title(props.t("Mismatch"))
      setdynamic_description(
        props.t("New password mismatched with retype password.")
      )
      return
    }

    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "create_account")
    urlencoded.append("phone_number", phoneNumber)
    urlencoded.append("phone_prefix", "+" + countryCode)
    urlencoded.append("password", password)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Create account", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_AUTH,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200 && postresponse.success) {
      if (postresponse.success) {
        if (referralCode && referralCode != "") {
          submitReferralCode(postresponse.member_id)
        } else {
          setsuccess_dlg(true)
          setdynamic_title(props.t("Account Created"))
          setdynamic_description(postresponse.message)
        }
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Password update failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const submitReferralCode = async uid => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "apply_referral_code")
    urlencoded.append("member_id", uid)
    urlencoded.append("referral_code", referralCode)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Apply referral", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200 && postresponse.success) {
      if (postresponse.success) {
        setsuccess_dlg(true)
        setdynamic_title(props.t("Registration complete"))
        setdynamic_description(postresponse.message)
      }
    } else {
      setsuccess_dlg(true)
      setdynamic_title(props.t("Registration complete"))
      setdynamic_description(postresponse.message)
    }
  }

  const [submitEnabled, setSubmitEnabled] = useState(false)

  function onPasswordChange(e) {
    setPassword(e.target.value)
    if (
      e.target.value.length >= 6 &&
      repassword != null &&
      repassword.length >= 6
    ) {
      setSubmitEnabled(true)
    } else setSubmitEnabled(false)
  }

  function onRePasswordChange(e) {
    setrePassword(e.target.value)
    if (
      password != null &&
      password.length >= 6 &&
      e.target.value.length >= 6
    ) {
      setSubmitEnabled(true)
    } else setSubmitEnabled(false)
  }

  function onReferralCodeChange(e) {
    setReferralCode(e.target.value)
  }

  const submitLogin = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "login")
    urlencoded.append("phone_number", phoneNumber)
    urlencoded.append("password", password)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("login", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_AUTH,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200 && postresponse.success) {
      if (postresponse.success) {
        localStorage.setItem("authUser", JSON.stringify(postresponse.data))
        if (postresponse.data.country_id) {
          // localStorage.setItem("country", postresponse.data.country_id)
          localStorage.setItem("country", 3)
        }

        if (redirectId) {
          history.push("/giftcard-share?id=" + redirectId)
          localStorage.removeItem("redirect_id")
        } else history.push("/home")
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Login failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {/* <CarouselPage /> */}
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                confirmBtnText={"Login Now"}
                onConfirm={() => {
                  submitLogin()
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                confirmBtnText={"Try Again"}
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{ minHeight: "100vh" }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="">
                      <Row
                        className="m-0"
                        style={{ height: "56px", backgroundColor: "#009FE2" }}
                      >
                        <Col xs={2}>
                          <Link to="/verification">
                            <Button className="h-100 m-0">
                              <i className="bx bx-arrow-back align-middle font-size-20 me-2 text-white" />
                            </Button>
                          </Link>
                        </Col>
                        <Col xs={8} className="align-self-center">
                          <p className="h-100 text-white font-size-15 my-auto text-center">
                            {props.t("Create Password")}
                          </p>
                        </Col>
                        <Col xs={2}></Col>
                      </Row>
                      <div className="mx-3" style={{ marginTop: "300px" }}>
                        <Form>
                          <Row className="mb-3 px-2 justify-content-center">
                            <Label className="font-size-15 font-weight-bold">
                              {props.t("Create your password")}
                            </Label>
                            <Col>
                              <InputGroup>
                                <Input
                                  type={pwVisibility ? "password" : "text"}
                                  className="form-control font-size-15"
                                  id="userMobile"
                                  placeholder={props.t("Password")}
                                  style={{
                                    height: "40px",
                                    border: "none",
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                  }}
                                  onChange={onPasswordChange}
                                />
                                <InputGroupAddon addonType="append">
                                  <button
                                    type="button"
                                    className="btn float-right"
                                    style={{
                                      backgroundColor: "white",
                                      borderTopLeftRadius: 0,
                                      borderBottomLeftRadius: 0,
                                      borderTopRightRadius: "8px",
                                      borderBottomRightRadius: "8px",
                                      border: "none",
                                      height: "40px",
                                    }}
                                    onClick={togglePwVisibility}
                                  >
                                    {pwVisibility ? (
                                      <i
                                        className="bx bxs-show align-middle font-size-20"
                                        aria-hidden="true"
                                      />
                                    ) : (
                                      <i
                                        className="bx bxs-chevron-right-square align-middle font-size-20"
                                        aria-hidden="true"
                                      />
                                    )}
                                  </button>
                                </InputGroupAddon>
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="mb-3 px-2 justify-content-center">
                            <Col>
                              <InputGroup>
                                <Input
                                  type={repwVisibility ? "password" : "text"}
                                  className="form-control font-size-15"
                                  id="userMobile"
                                  placeholder={props.t(
                                    "Re-enter your password"
                                  )}
                                  style={{
                                    height: "40px",
                                    border: "none",
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                  }}
                                  onChange={onRePasswordChange}
                                />
                                <InputGroupAddon addonType="append">
                                  <button
                                    type="button"
                                    className="btn float-right"
                                    style={{
                                      backgroundColor: "white",
                                      borderTopLeftRadius: 0,
                                      borderBottomLeftRadius: 0,
                                      borderTopRightRadius: "8px",
                                      borderBottomRightRadius: "8px",
                                      border: "none",
                                      height: "40px",
                                    }}
                                    onClick={togglerePwVisibility}
                                  >
                                    {repwVisibility ? (
                                      <i
                                        className="bx bxs-show align-middle font-size-20"
                                        aria-hidden="true"
                                      />
                                    ) : (
                                      <i
                                        className="bx bxs-chevron-right-square align-middle font-size-20"
                                        aria-hidden="true"
                                      />
                                    )}
                                  </button>
                                </InputGroupAddon>
                              </InputGroup>
                            </Col>
                          </Row>

                          <Row className="mb-3 px-2">
                            <Col>
                              {/* <Link to="/login"> */}
                              <button
                                className={
                                  submitEnabled
                                    ? "btn btn-primary btn-block waves-effect waves-light w-100 font-size-18"
                                    : "btn btn-light btn-block waves-effect waves-light w-100 font-size-18 text-muted"
                                }
                                disabled={!submitEnabled}
                                style={{ borderRadius: "8px" }}
                                onClick={submitResetPassword}
                              >
                                <strong>{props.t("Create Account")}</strong>
                              </button>
                              {/* </Link> */}
                            </Col>
                          </Row>

                          {/* <Row className="mb-3 px-2 font-size-15">
                            <p
                              className="mb-0 text-center"
                              style={{ color: "#4A4A4A" }}
                            >
                              By creating an account, I agree to the{" "}
                              <a href="#" style={{ color: "#4A4A4A" }}>
                                <u>Terms & Conditions</u>
                              </a>
                              {" and "}
                              <a href="#" style={{ color: "#4A4A4A" }}>
                                <u>Privacy Policy</u>
                              </a>
                            </p>
                          </Row> */}

                          <Row className="mt-5 px-2 justify-content-center">
                            <Label
                              className="font-size-15 font-weight-bold text-center"
                              style={{ color: "#616E7C" }}
                            >
                              {props.t("Enter your referral code")}
                            </Label>
                            <Col>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control font-size-15 text-center"
                                  id="userReferral"
                                  placeholder="Enter your referral Code"
                                  style={{
                                    height: "40px",
                                    border: "none",
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                  }}
                                  onChange={onReferralCodeChange}
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(SetPassword)

SetPassword.propTypes = {
  t: PropTypes.any,
}
